// Dependencies
import { useDispatch } from "react-redux";

// Actions
import { ChangePage } from "../../actions/navigation.actions";

/**
 * @deprecated Prefer react-router primitives in new code: `useNavigate` from `react-router-dom`
 * for imperative navigation, or the declarative `<Navigate to=... replace />` component for
 * effect-driven redirects. This Redux-dispatched wrapper predates react-router v6 adoption and
 * remains in place only for legacy callers.
 */
const useNavigate = () => {
	const dispatch = useDispatch<any>();

	const navigate = (path: string) => {
		dispatch(ChangePage(path));
	};

	return navigate;
};

export default useNavigate;
